import React from 'react'
import './Skills.css'
const Skills = ({text}) => {
  return (
    <div className="Skills">
      <p className='SkillsText'>{text}</p>
    </div>
  )
}

export default Skills
